import { render } from "./App.vue?vue&type=template&id=28afe186"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=28afe186&lang=less"

import exportComponent from "D:\\桌面\\项目\\网站\\宠趣SDK\\new_choneQu_sdk_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__